<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="12"
                md="3"
                xl="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in holiday name here"
                  append-icon="search"
                  label="Search holiday"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
                xl="4"
              >
                <v-select
                  v-model="holidayFilter"
                  :items="holidayTypes"
                  item-text="text"
                  item-value="value"
                  label="Holiday Types"
                  placeholder=" All / National / Regional"
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
                offset-md="4"
                xl="2"
                offset-xl="2"
              >
                <!-- <setup-holidays-dialog-create
                  @created="refreshData"
                /> -->
              </v-col>
            </v-row>
          </v-card-actions>

          <v-data-table
            :headers="headers"
            :items="filteredHolidays"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span class="font-weight-bold">
                  {{ item.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.is_national="{ item }">
              <div>
                <span class="font-weight-bold">
                  {{ item.is_national? 'Yes' : 'No' }}
                </span>
              </div>
            </template>
            <!-- <template v-slot:item.action="{ item }">
              <setup-holidays-dialog-edit
                :holiday="item"
                @updated="refreshData"
              />
              <span class="mx-1" />
            </template> -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      // SetupHolidaysDialogCreate: () => import('@/components/setup/holidays/DialogCreate'),
      // SetupHolidaysDialogEdit: () => import('@/components/setup/holidays/DialogEdit'),
    },
    metaInfo () {
      return {
        title: 'Holidays',        
      }
    },
    data () {
      return {
        holidayFilter: 'all',
        holidayTypes: [
          { value: 'all', text: 'All' },
          { value: 'regional', text: 'Regional' },
          { value: 'national', text: 'National' },
        ],
        holidays: [],
        search: '',
        tableLoading: true,
        headers: [
          {
            text: 'Holidays',
            align: 'left',
            value: 'name',
          },
          {
            text: 'National Holiday',
            value: 'is_national',
            align: 'center',
          },
          {
            text: '',
            value: 'action',
            align: 'left',
          },
        ],
      }
    },
    computed: {
      filteredHolidays () {
        if (this.holidayFilter === 'all') {
          return this.holidays
        }
        
        return this.holidays.filter((holiday) => {
          if (this.holidayFilter === 'national') {            
            return holiday.is_national === 1
          } else {
            return holiday.is_national === 0
          }
        })
      },
    },
    created () {
      this.refreshData()
    },   
    methods: {
      refreshData () {
        this.loadHolidays()
      },
      loadHolidays () {        
        this.tableLoading = true

        this.$api.holidays().list()
          .then((response) => {
            this.holidays = response.data
            this.tableLoading = false
          })
      },
    },
  }
</script>

<style lang='css' scoped>
</style>
